import React from "react";
import Navbar from "../Components/Navbar";
import subpagebanner from "../Assets/subpagebanner.png";
import footer from "../Assets/footer.png";
import partnerlogos from "../Assets/partnerlogos.png";
import Card from "../Components/Card.jsx";
import Card1 from "../Components/Card1.jsx";
import Card2 from "../Components/Card2.jsx";
import Card3 from "../Components/Card3.jsx";
import Card4 from "../Components/Card4.jsx";
import Card5 from "../Components/Card5.jsx";
import Card6 from "../Components/Card6.jsx";
import Card7 from "../Components/Card7.jsx";
import Card8 from "../Components/Card8.jsx";
import Card9 from "../Components/Card9.jsx";
import Card10 from "../Components/Card10.jsx";
import Card11 from "../Components/Card11.jsx";
import Card12 from "../Components/Card12.jsx";
import Card13 from "../Components/Card13.jsx";
import Card14 from "../Components/Card14.jsx";
import Card15 from "../Components/Card15.jsx";

const About = () => {
  return (
    <div className="App">
      <Navbar />
      <img src={subpagebanner} alt="" />
      <div className="home-container"></div>
      <div className="bodycopy-container ">
        <h1 className="primary-header">Community</h1>
        <br />
        <br />
        <br />
        <h2 className="secondary-heading center-text">Mentors</h2>
        <br />
        <br />
        <div className="card-center-style">
          <Card /> {/* Clifton Phua */}
          <Card5 /> {/* Goh Han Leong */}
          <Card6 /> {/* Henry Kang */}
          <Card1 /> {/* Mengling 'Mornin' Feng */}
          <Card2 /> {/* Praveen Deorani*/}
          <Card3 /> {/* Roy Goh */}
          <Card4 /> {/* Sean Lam */}
          <Card7 /> {/* Wilson Wen Bin Goh */}
        </div>
        <br />
        <br />
        <br />
        <br />
        <br />
        <h2 className="secondary-heading center-text">Judges</h2>
        <br />
        <br />

        <div className="card-center-style">
          <Card8 /> {/* Alan Goh */}
          <Card9 /> {/* Colin Lim */}
          <Card11 /> {/* James Pang */}
          <Card10 /> {/* Lawrence Wee */}
          <Card12 /> {/* Robert Morris */}
          <Card13 /> {/* Sng Hock Lin */}
          <Card14 /> {/* Teo Hock Hai */}
          <Card15 /> {/* XianWu */}
        </div>
        <br />
        <br />
        <h3 class="textbold center-text">
          To learn more about the NUS Business Analytics Centre, please visit: 
          <a href="https://msba.nus.edu.sg/://gurugame.ai/">
            https://msba.nus.edu.sg/{" "}
          </a>
        </h3>
        <br />
        <br />
        <br />
        <p className="center-text">
          Proudly Supported by Our Technical Partners:
          <br />
          <br />
          <img
            src={partnerlogos}
            alt="Partner Logos"
            className="partnerlogos-style"
          />
        </p>
        <br />
        <br />
        <br />

        <img src={footer} alt="" />

        <br />
      </div>
    </div>
  );
};

export default About;
